<template>
  <div>
    <div class="container-fluid work" id="work">
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="home-banner dark">
            <swiper ref="homeBanner">
              <div class="banner-slide d-flex align-items-center justify-content-center" v-for="(banner,key) in totalBanners" :key="key">
                <div class="container d-flex align-items-center justify-content-center">
                  <div class="banner-message text-center col-xs-10 col-sm-12 col-md-10 col-lg-11">
                    <imageBlur v-if="banner.icon" class="icon" :url="banner.iconImg.url" :type="banner.iconImg.type" :alt="banner.title"></imageBlur>
                    <h2 v-if="banner.title">{{banner.title[lang]}}</h2>
                    <p v-if="banner.text">{{banner.text[lang]}}</p>
                    <router-link v-if="banner.link" tag="a" :to="{path: banner.url}">{{banner.link[lang]}}</router-link>
                  </div>
                </div>
                <imageBlur v-if="banner.bannerImg" class="banner-bg" :url="banner.bannerImg.url" :type="banner.bannerImg.type" :alt="banner.title"></imageBlur>
              </div>
            </swiper>
            <div v-if="totalBanners < 1" class="banner-nav">
              <a href="#" class="prev" @click="prev"></a><a href="#" class="next" @click="next"></a>
            </div>
          </div>
        </div>
      </div>
      <div class="row img-row">
        <div class="img-col col-lg-3 col-md-6 col-sm-6 col-xs-12" v-for="(project, key) in selectedProjects" :key="key">
          <imageBlock :project="project"></imageBlock>
        </div>
      </div>
      <div v-if="$locale.sectionBreak" class="row no-gutters">
        <div class="section-break col-md-12 d-flex align-items-center justify-content-center light">
          <div class="container d-flex align-items-center justify-content-center">
            <div class="text-center col-xs-12 col-sm-12 col-md-10 col-lg-12">
              <h2 v-if="$locale.sectionBreak.title">{{$locale.sectionBreak.title[lang]}}</h2>
              <p v-if="$locale.sectionBreak.title">{{$locale.sectionBreak.text[lang]}}</p>
              <router-link v-if="$locale.sectionBreak.link" tag="a" class="btn btn-primary" :to="{path: $locale.sectionBreak.linkUrl}">{{$locale.sectionBreak.link[lang]}}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <footerNotice></footerNotice>
    </div>
  </div>
</template>

<script>
import imageBlock from '../../src/pages/components/imageBlock';
import imageBlur from '../../src/pages/components/imageBlur';
import footerNotice from '../../src/pages/components/footerNotice';
import { EventBus } from '../../src/pages/components/eventBus.js';
import {Swiper} from 'vue2-swiper'

export default {
    components: {
        footerNotice,
        imageBlock,
        imageBlur,
        Swiper
    },
    name: "home",
    data() {
      return {
        currentOrder: 'id',
        projects: [],
        totalProjects: [],
        totalBanners: [],
        selectedProjects: [],
        lang: '',
        img: process.env.VUE_APP_PUBLIC + '/img/bg_footer.jpg',
        totalShow: 4,
        loaded: false,
        counter: 0,
        notice: true,
        bannerData: [
          25,26,27,28,29,30,32,31
        ]
      }
    },
    methods: {
      myEventHandler() {
        this.$forceUpdate();
      },
      loadBanners() {
        this.totalBanners = this.$locale.banners;
      },
      loadProjects() {
        this.totalProjects = this.$dataObj;
        this.totalProjects = this.totalProjects.slice().reverse();
        this.getProjects();
      },
      loadSelectedProjects() {
        const sweeterArray = this.$dataObj.slice().reverse().map(pro => {
          for (var i = 0; i < this.$locale.selectedProjects.length; i++) {
            if(pro.id == this.$locale.selectedProjects[i]) {
              this.selectedProjects.push(pro);
            }
          }
        })
      },
      callProjects(sPos, ePos) {
        for (var i = sPos; i < ePos; i++) {
          if(this.totalProjects[i] !== undefined) {
            this.projects.push(this.totalProjects[i]);
          }
        }
      },
      getProjects() {
        this.callProjects(0,this.totalShow);
        EventBus.$on('workHeight', val => {
          if(val < window.innerHeight) {
            this.callProjects(this.totalShow,this.totalShow + 4);
            this.totalShow = this.totalShow + 4;
          }
        });
      },
      prev(){
        this.$refs.homeBanner.prev()
      },
      next(){
        this.$refs.homeBanner.next()
      },
      scroll() {
        window.onscroll = () => {
          let bottomWindow = document.documentElement.scrollTop + window.innerHeight;
          let bottomWork = 0;
          if(document.getElementById("work")) {
            bottomWork = document.getElementById("work").offsetHeight;
          }
          let crossBottom = bottomWindow >= bottomWork;

          if(crossBottom == false) {
            this.counter = 0;
          }

          if (crossBottom) {
            if(this.counter === 0) {
              this.callProjects(this.totalShow,this.totalShow + 4);
            }
            this.totalShow = this.totalShow + 4;
            this.counter = 1;
            this.notice = false;
          }
        };
      }
    },
    mounted() {
      window.addEventListener("resize", this.myEventHandler);
      this.loadSelectedProjects();
      this.loadBanners();
      this.scroll();

      EventBus.$on('lang', lang => {
        this.lang = lang;
      });
      this.lang = this.$cookie.get('pixel-deep.com');
    }
}

</script>

<style lang="scss" scoped>
  .container {
    background: none;
  }

  .load {
    height: 80px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    background: darken(#AD1C56, 10%);

    .btn {
      background: none;
      color: #fff;
      text-transform: uppercase;
      font-size: 13px;
      padding-left: 2em;
      padding-right: 2em;
      border: 1px solid rgba(#fff, 0.5);
    }

    .btn:hover {
      color: #000;
      background: #fff;
    }
  }

.work {
  z-index: 1;
  background: none;
}

.img-col {
  background: none;
}

.btn-outline {
  margin: 30px auto;
  border: 1px solid rgba(#fff, 0.2);
  border-radius: 0;
  color: #fff;
  font-size: 13px;
  transition: all 0.3s;

  &:hover {
    transition: all 0.3s;
    padding: 15px 40px;
  }
}
</style>
